import { UUID } from 'crypto';
import { PaginatorPageChangeEvent } from 'primereact/paginator';
import { MouseEventHandler } from 'react';

export type ToastData = {
	detail: string;
	severity: 'success' | 'info' | 'warn' | 'error';
	summary: string;
};

export type RequestStateViewProps = {
	isLoading: boolean;
	isError: boolean;
	color?: string;
	message?: string;

	errorMessage?: string;
	data: { data: any | undefined } | any;
	refetch?: MouseEventHandler<HTMLButtonElement>;
};

export type TableColumnFilter = {
	visibility: boolean;
	placeholder: string;
};

export type TableColumn = {
	field?: string;
	headerName: string;
	body?: any;
	filter?: TableColumnFilter;
	sortable?: boolean;
};

export type Pagination = {
	first: number;
	totalRecords: number;
	totalPages: number;
	rowsPerPageOption: number[];
	onPageChange: (event: PaginatorPageChangeEvent) => void;
};


export type PaginatedResponse = {
	totalPages: number;
	currentPage: number;
	totalItems: number;
	itemsPerPage: number;

};


export type BaseTableProps = {
	data: any[];
	pagination?: Pagination;
	columns: TableColumn[];
	emptyMessage: string;
	globalFilter?: boolean;
	setFilters: Function;
	setPage?: Function;
	filters: any;
	globalButton?: { text: string; action: MouseEventHandler<HTMLButtonElement>; icon?: string; loading?: boolean };
	loading?: boolean;
};

export type UserState = {
	role: 'Root' | 'Admin' | 'Usher' | 'Attendee';
	access_token: string;
	refresh_token: string;
};

export type UserInfo = {
	id: string;
	email: string;
	name: string;
};

export type Answer = {
	id: string;
	answer: string;
	questionId: string;
};

export type Attendee = {
	id: UUID;
	email: string;
	name: string;
	specialty?: string;
	region?: string;
	fields?: Object;
	actions: AttendeeAction[];
	surveyAnswers?: { question: Question; answers: Answer[] }[];
};

export type RegistrationInfo = {
	attendee: Attendee;
	eventId: UUID;
};

export type AuthPayload = {
	target: string;
	email: string;
	password: string;
};

export type Icon = {
	id: UUID;
	name: string;
	iconClass: string;
};

export type Admin = {
	id: UUID;
	name: string;
	email: string;
	isRoot: boolean;
};

export enum ADMIN_FORM_TYPE {
	ADD_NEW_ADMIN = 'ADD_NEW_ADMIN',
	RESET_PASSWORD = 'RESET_PASSWORD',
	EDIT_ADMIN = 'EDIT_ADMIN',
}

export type Usher = {
	id: UUID;
	email: string;
	name: string;
};

export enum USHER_FORM_TYPE {
	ADD_NEW_USHER = 'ADD_NEW_USHER',
	RESET_PASSWORD = 'RESET_PASSWORD',
	EDIT_USHER = 'EDIT_USHER',
}

export type Partner = {
	id: UUID;
	name: string;
	logo?: string;
	events?: EventType[];
};

export type Choices = {
	id: UUID;
	text: string;
	questionId?: string;
};

export type Question = {
	id: UUID;
	text: string;
	isRequired: boolean;
	type: string;
	surveyId?: UUID;
	choices?: Choices[];
	responsesCount?: number;
	chartData?: { labels: string[]; data: number[] };
	ratingRange?: number;
};

export enum SURVEY_QUESTION_TYPES {
	TEXT = 'TEXT',
	MCQ = 'MCQ',
	CHECKBOX = 'CHECKBOX',
	RATING = 'RATING',
}


export enum Registration_QUESTION_TYPES {
	TEXT = 'TEXT',
	DropDown = 'DropDown',

}

export type Survey = {
	id: UUID;
	title: string;
	description?: string;
	startDate: string | Date;
	endDate: string | Date;
	eventId?: UUID | string;
	questions?: Question[];
};

export type EventType = {
	id?: UUID;
	name: string;
	description: string;
	timeZone: string;
	startDate: string | Date;
	endDate: string | Date;
	primaryColor: string;
	secondaryColor: string;
	hasFooter: boolean;
	footerContent: string;
	headerImage?: string;
	specialty: string;
	partnerId: string;
	partner?: Partner;
	isReminderTaskExecute: boolean;
	isSummaryTaskExecute: boolean;
	fields: {
		key: string;
		title: string;
		placeHolder: string;
		type: string;
		icon: string;
		required: boolean;
	}[];
	ushers: Usher[] | any[];
	survey: Survey;
};

export type EventSession = {
	id?: UUID;
	name: string;
	description: string;
	image?: string;
	eventId: UUID;
};

export type Field = {
	key: string;
	title: string;
	placeHolder: string;
	required: boolean;
	type: string;
	icon: string;
	options?: string[];
};

export type Session = {
	id: UUID;
	eventId: UUID;
	name: string;

	attendees?: any[];
};

export type AttendeeAction = {
	id: UUID;
	sessionId: UUID;
	attendeeId: UUID;
	actionTime: string;
	attendee?: Attendee;
	session?: Session;
};


export type MailTask = {
	id: UUID;
	eventId: UUID;
	sending: number;
	failed: number;
	canRetries: number;
	type: 'REMINDER' | 'SUMMARY';
};


export type Mail = {
	id: UUID;
	receiver: string;
	retriesCount: number;
	status: 'SENDING' | 'FAILED'
	error?: string
};